<template>
  
  <div class="vote_button_row_container">
    
    <div class="vote_button_row">

      <!-- "SKIP" VOTE BUTTON -->
      <button class="btn btn-success btn_vote btn_vote_complete" type="button"
      v-if="is_single_contest != 'true'"
      @click="skip_vote"
      >
        Skip to Next <font-awesome-icon icon="long-arrow-alt-right"></font-awesome-icon>
      </button>

      <!-- "ALL CONTESTS" BUTTON -->
      <button class="btn btn-success btn_vote btn_vote_complete" type="button"
      v-if="is_single_contest == 'true'"
      @click="view_all_contests"
      >
        View List <font-awesome-icon icon="long-arrow-alt-right"></font-awesome-icon>
      </button>

      <transition
      name="" 
      mode="out-in"
      enter-active-class="animated tada faster" 
      >

        <!-- SEND VOTE BUTTON -->
        <button class="btn btn-primary btn_vote"
        v-if="vote_status != 'complete'"
        :class="{disabled: vote_status != 'ready'}"
        :disabled="vote_status != 'ready'"
        @click="send_vote"
        key="vote_button"
        >
          <span
          v-if="vote_status != 'processing'"
          >
            Send Vote
          </span>
          <span
          v-else
          >
            ...
          </span>
          
        </button>
        

        <!-- CONFIRMATION BUTTON -->
        <button class="btn btn-success btn_vote btn_vote_complete"
        v-if="vote_status == 'complete'"
        key="vote_button_complete"
        >
        
          <font-awesome-icon icon="check-circle"></font-awesome-icon> 
        
        </button>

        

      </transition>
    </div>

    <!-- PROGRESS BAR FOR VOTING -->
    <progress-bar

    :current_count="voted_count"
    :max_count="total_contests"
    ></progress-bar>

  </div>

</template>

<script>
import ProgressBar from '@/components/progress_bar/progress_bar.vue';

export default {
  name: 'fixed_vote_button_row',
  props: [
    'vote_enabled',
    'vote_status',
    'total_contests',
    'voted_count',
    'is_single_contest'
  ],
  data () {
    return {
      has_submitted_vote: false,
    }
  },
  methods: {
    send_vote: function() {
      let vm = this;
      
      vm.has_submitted_vote = true;

      vm.$emit('contest_vote_submitted', '');

      // ARTIFICIAL DELAY TO SIMULATE SENDING VOTE AND GETTING RESPONSE FROM SERVER
      /*setTimeout(function() {
        vm.$emit('contest_vote_submitted', '');
      }, 1000);*/
      
      
    },
    skip_vote: function() {
      this.$emit('skip_vote', '');
    },
    view_all_contests: function() {
      // TOGGLE FORCE REFRESH TO TRUE
      this.$root.store.voting.change_force_unvoted_refresh(true);

      // GOTO VOTE PAGE
      this.goto_path('/vote/');
    },
    goto_path: function(path_name) {
      this.$root.store.goto_path(path_name);
    }
  },
  components: {
    ProgressBar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

.vote_button_row_container {

  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 5;

  .vote_button_row {
    display: flex;
    justify-content: space-between;
    padding: 1.2rem 1rem;
    width: 100%;
    background: $dcom-teal;
    box-shadow: -1px -1px 4px #777;

    .btn_vote {
      font-size: 1.0em;
      font-weight: bold;
      text-transform: uppercase;
      padding: 0.5em 1em;
      background: #FFF;
      color: $dcom-teal;
      border-color: $dcom-teal;
    }
  }

}


</style>


// WEBPACK FOOTER //
// src/features/vote/fixed_vote_card_button_row.vue